/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";
import { checkInComplianceRefreshKeys } from "./sharedRefreshKeys";

const baseDiscountCardsKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.discount_cards),
  getBaseQueryKey(Query_Keys.discount_card_logs),
  getBaseQueryKey(Query_Keys.discount_cards_dropdown),
  getBaseQueryKey(Query_Keys.industry_discount_cards),
  getBaseQueryKey(Query_Keys.eligible_industry_discount_cards),
);

const changedDiscountCardsKeys = mergeQueryKeys(baseDiscountCardsKeys, checkInComplianceRefreshKeys);

export const discountCardMutationKeyGroups = {
  create: baseDiscountCardsKeys,
  update: changedDiscountCardsKeys,
  delete: changedDiscountCardsKeys,
};
